<template>
  <div class="mt-4">
    <span
      class="mt-6 text-sm uppercase text-gray-500 tracking-wider leading-4"
    >
      Background Color
    </span>
    <div
      class="flex flex-row p-2 bg-gray-100 border border-gray-300 rounded-md"
    >
      <div class="display-none">
        <v-swatches
          v-model="element.backgroundColor"
          swatches="text-advanced"
          class="p-0 rounded-md mt-1 mr-4"
          show-fallback
          fallback-input-type="color"
        ></v-swatches>
      </div>
    </div>
  </div>
</template>

<script>
// import Component from "../component_location"
import VSwatches from "vue-swatches";

export default {
  components: { VSwatches },

  props: {
    element: { type: Object, default: () => {} },
    full: { type: Boolean, default: false },
  },

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style>
.vue-swatches__fallback__button {
  font-family: Inter !important;
  font-size: 12px;
  padding: 5px !important;
  margin-top: 5px !important;
  font-weight: normal;
  text-transform: uppercase;
}
</style>
